import { css } from 'styled-components';

const flex_container = css`
    display: flex;
    display: -ms-flexbox;
`;
const flex_direction = function () {
  let direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'row';
  return css`
    flex-direction: ${direction};
    -ms-flex-direction: ${direction};
`;
};
const flex = function () {
  let flexitems;
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (args.length === 1) {
    if (args[0] === 'initial') {
      flexitems = '0 1 auto';
    } else if (args[0] === 'auto') {
      flexitems = '1 1 auto';
    } else if (args[0] === 'none') {
      flexitems = '0 0 auto';
    } else {
      flexitems = `${args} 1 0%`;
    }
  } else {
    flexitems = args.join(' ');
  }
  return css`
        flex: ${flexitems};
        -ms-flex: ${flexitems};
    `;
};

export { flex, flex_container, flex_direction };
